(function () {
  'use strict';

  function money(cents) {
    var currency = (window.WTechRoutes && window.WTechRoutes.currency) || 'AUD';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-AU', {
        style: 'currency',
        currency: currency
      }).format(Number(cents || 0) / 100);
    } catch (error) {
      return '$' + (Number(cents || 0) / 100).toFixed(2);
    }
  }

  function showToast(message) {
    var toast = document.querySelector('[data-cart-toast]');
    if (!toast) return;
    var text = toast.querySelector('[data-cart-toast-message]');
    if (text) text.textContent = message;
    toast.hidden = false;
    clearTimeout(showToast.timer);
    showToast.timer = setTimeout(function () { toast.hidden = true; }, 4500);
  }

  function updateCartCount() {
    if (!window.WTechRoutes || !window.WTechRoutes.cartJson) return Promise.resolve();
    return fetch(window.WTechRoutes.cartJson, { headers: { Accept: 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (node) {
          node.textContent = cart.item_count;
        });
      })
      .catch(function () {});
  }

  function initAjaxCart() {
    document.addEventListener('submit', function (event) {
      var form = event.target.closest('.product-card-form, .product-form');
      if (!form || !window.fetch || !window.FormData || !window.WTechRoutes) return;
      var submitter = event.submitter || form.querySelector('[type="submit"]');
      if (!submitter || submitter.disabled) return;
      if (form.classList.contains('product-form') && !submitter.matches('[data-product-add]')) return;
      if (form.classList.contains('product-card-form') && !submitter.matches('[data-add-to-cart]')) return;

      event.preventDefault();
      submitter.disabled = true;
      submitter.classList.add('is-loading');
      form.classList.add('is-loading');

      fetch(window.WTechRoutes.cartAdd + '.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      })
        .then(function (response) {
          return response.json().then(function (data) {
            if (!response.ok) throw new Error(data.description || data.message || 'Unable to add this item.');
            return data;
          });
        })
        .then(function (item) {
          return updateCartCount().then(function () {
            showToast((item.product_title || 'Item') + ' added to cart.');
          });
        })
        .catch(function (error) {
          showToast(error.message || 'Unable to add this item.');
        })
        .finally(function () {
          submitter.disabled = false;
          submitter.classList.remove('is-loading');
          form.classList.remove('is-loading');
        });
    });
  }

  function initMobileNavigation() {
    var toggle = document.querySelector('[data-mobile-nav-toggle]');
    var nav = document.querySelector('[data-main-nav]');
    if (!toggle || !nav) return;

    function setOpen(open) {
      nav.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.classList.toggle('is-menu-open', open);
    }

    toggle.addEventListener('click', function () {
      setOpen(!nav.classList.contains('is-open'));
    });

    window.addEventListener('resize', function () {
      if (window.innerWidth > 980) setOpen(false);
    });
  }

  function initDesktopMenus() {
    var details = document.querySelectorAll('[data-nav-details]');
    var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');

    details.forEach(function (item) {
      item.addEventListener('mouseenter', function () {
        if (finePointer.matches && window.innerWidth > 980) item.open = true;
      });
      item.addEventListener('mouseleave', function () {
        if (finePointer.matches && window.innerWidth > 980) item.open = false;
      });
    });

    document.addEventListener('click', function (event) {
      details.forEach(function (item) {
        if (!item.contains(event.target) && window.innerWidth > 980) item.open = false;
      });
    });
  }

  function initCarousels() {
    document.querySelectorAll('[data-carousel]').forEach(function (carousel) {
      var track = carousel.querySelector('[data-carousel-track]');
      var previous = carousel.querySelector('[data-carousel-prev]');
      var next = carousel.querySelector('[data-carousel-next]');
      if (!track) return;

      function amount() {
        var first = track.firstElementChild;
        return first ? first.getBoundingClientRect().width + 18 : track.clientWidth * 0.8;
      }

      function update() {
        var max = Math.max(0, track.scrollWidth - track.clientWidth - 2);
        if (previous) previous.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max;
      }

      if (previous) previous.addEventListener('click', function () { track.scrollBy({ left: -amount(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: amount(), behavior: 'smooth' }); });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  function initProductGallery() {
    document.querySelectorAll('[data-product-gallery]').forEach(function (gallery) {
      var main = gallery.querySelector('[data-gallery-main]');
      if (!main) return;
      gallery.querySelectorAll('[data-media-html]').forEach(function (button) {
        button.addEventListener('click', function () {
          main.innerHTML = button.dataset.mediaHtml;
          gallery.querySelectorAll('.product-thumbnail').forEach(function (thumb) { thumb.classList.remove('is-active'); });
          button.classList.add('is-active');
        });
      });
    });
  }

  function initProductVariants() {
    document.querySelectorAll('[data-product-section]').forEach(function (section) {
      var select = section.querySelector('[data-variant-select]');
      var json = section.querySelector('[data-product-json]');
      if (!select || !json) return;

      var variants;
      try { variants = JSON.parse(json.textContent); } catch (error) { return; }
      var price = section.querySelector('[data-product-price]');
      var sku = section.querySelector('[data-product-sku]');
      var addButton = section.querySelector('[data-product-add]');
      var addLabel = section.querySelector('[data-product-add-label]');

      select.addEventListener('change', function () {
        var variant = variants.find(function (item) { return String(item.id) === select.value; });
        if (!variant) return;

        if (price) {
          price.innerHTML = '<span>' + money(variant.price) + '</span>' +
            (variant.compare_at_price && variant.compare_at_price > variant.price ? '<s>' + money(variant.compare_at_price) + '</s>' : '');
        }
        if (sku) sku.textContent = variant.sku || '';
        if (addButton) addButton.disabled = !variant.available;
        if (addLabel) addLabel.textContent = variant.available ? 'Add to cart' : 'Sold out';
        if (window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        }
      });
    });
  }

  function initRecommendations() {
    document.querySelectorAll('[data-product-recommendations]').forEach(function (container) {
      var url = container.dataset.url;
      if (!url) return;
      fetch(url)
        .then(function (response) { return response.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-product-recommendations]');
          if (fresh && fresh.innerHTML.trim()) {
            container.className = fresh.className;
            container.innerHTML = fresh.innerHTML;
          }
        })
        .catch(function () {});
    });
  }

  function init() {
    initMobileNavigation();
    initDesktopMenus();
    initCarousels();
    initAjaxCart();
    initProductGallery();
    initProductVariants();
    initRecommendations();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', function () {
    initCarousels();
    initProductGallery();
    initProductVariants();
  });
})();
